import React from 'react';
import { Box, Typography } from '@mui/material';

const AnalyticsPage = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Analytics
      </Typography>
      {/* Add your analytics page content here */}
    </Box>
  );
};

export default AnalyticsPage; 